export default "__VITE_ASSET__e5f1caec__"